export default "__VITE_ASSET__CEuOjUWk__"